import { queryKeys } from '@/lib/query-keys';
import { addressClient } from '@/lib/api/ts-rest';
import type {
  Address,
} from '@octave/contracts';
import { useQuery } from '@tanstack/react-query';


export const useGetAddresses = (organizationId: string | undefined) => {
  return useQuery<Address[], Error>({
    queryKey: queryKeys.addresses.list(organizationId),
    queryFn: async () => {
      const res = await addressClient.listAddresses({
        query: { organizationId: organizationId! },
      });
      if (res.status !== 200) throw new Error('Failed to load addresses');
      return res.body;
    },
    enabled: !!organizationId,
  });
};
